<template>
    <common-modal v-if="isOpen" width="medium" @close="emitEvent({ name: 'close' })">
        <common-content-wrapper width="small">
            <common-content-spacer height="large">
                <common-page-header
                    :heading="$t('modals.remove_professional_info.heading', { name })"
                    :isCenter="true"
                    contentSpacing="medium"
                ></common-page-header>

                <common-buttons>
                    <common-button
                        :label="$t('common.microcopy.cancel')"
                        type="secondary"
                        size="large-long"
                        @click="emitEvent({ name: 'close' })"
                    ></common-button>
                    <common-button
                        :label="$t('common.microcopy.confirm')"
                        type="primary"
                        size="large-long"
                        @click="removeInfo"
                    ></common-button>
                </common-buttons>
            </common-content-spacer>
        </common-content-wrapper>
    </common-modal>
</template>

<script>
    export default {
        props: {
            isOpen: { type: Boolean, required: true },
            index: { type: Number, default: undefined },
            name: { type: String, default: '' },
        },

        methods: {
            removeInfo() {
                this.emitEvent({ name: 'info-removed', payload: this.index })
            },
        },
    }
</script>
